export default __webpack_public_path__ + "static/media/title.c5aba76d.png";